import * as actionTypes from './actionTypes';

/**
 *  Initial State searchData Reducer
 */
const initialState = {
  data: '',
};
/**
 * On Get searchData Start Action
 */
const getSearchTermStateData = (state, action) => {
  return { ...state, data: action.payload };
};

/**
 * Update searchData Reducer
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SEARCH_TERM_DATA:
      return getSearchTermStateData(state, action);
    default:
      return state;
  }
};
